var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{class:['material-icons', _vm.size, _vm.color, _vm.alignment],on:{"click":function($event){return _vm.$emit('click')}}},[_vm._v(_vm._s(_vm.iconName))])
}
var staticRenderFns = []

export { render, staticRenderFns }